import React, { useState, useEffect } from 'react';
import './ModalCriarAlbum.css';

const ModalCriarAlbum = ({ isOpen, onClose, onCreateAlbum }) => {
  const [albumName, setAlbumName] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Limpa o form quando o modal abre
  useEffect(() => {
    if (isOpen) {
      setAlbumName('');
      setError('');
      // Focus no input
      setTimeout(() => {
        const input = document.getElementById('album-name-input');
        if (input) input.focus();
      }, 100);
    }
  }, [isOpen]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setAlbumName(value);
    setError('');
  };

  const validateAndCreate = async () => {
    // Validações
    if (!albumName.trim()) {
      setError('Digite um nome para o álbum');
      return;
    }

    if (albumName.length > 50) {
      setError('Nome não pode ter mais de 50 caracteres');
      return;
    }

    try {
      setIsLoading(true);
      await onCreateAlbum(albumName);
      setAlbumName('');
      setError('');
      onClose();
    } catch (err) {
      setError(err.message || 'Erro ao criar álbum');
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !isLoading) {
      validateAndCreate();
    }
    if (e.key === 'Escape') {
      onClose();
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-card modal-criar-album">
        <h2 className="modal-titulo">Criar novo álbum</h2>

        <div className="modal-body">
          <div className="form-group">
            <label htmlFor="album-name-input" className="form-label">
              Nome do álbum
            </label>
            <input
              id="album-name-input"
              type="text"
              className={`form-input ${error ? 'input-error' : ''}`}
              placeholder="Ex: Copa do Mundo 2026 Capa Dura" 
              value={albumName}
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
              disabled={isLoading}
              maxLength="50"
              autoComplete="off"
            />
            {error && <p className="form-error">{error}</p>}
            <p className="form-hint">
              {albumName.length}/50 caracteres
            </p>
          </div>
        </div>

        <div className="modal-footer">
          <button
            className="btn-secundario"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancelar
          </button>
          <button
            className="btn-primario"
            onClick={validateAndCreate}
            disabled={isLoading}
          >
            {isLoading ? 'Criando...' : 'Criar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalCriarAlbum;
